import React from 'react';
import smart_classroom from '../../assests/img/classroom.jpg';

const SmartClassrooms = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Smart Classrooms</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Smart Classrooms
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p style={{ textAlign: "justify" }}>
                                                    <img src={smart_classroom} alt="smart_classroom" width="100%" />
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    Karamchand Memorial School is the leading school in the area which offers the best digital classes to the students as it’s the need of the modern education to provide digital classes along with well equipped labs with the required hardwares and softwares and it’s maintained by IT team of the school. This is the need of the hour to provide the latest technology based learning to the students which enhance their capabilities as per the global standard.
                                                </p>
                                                <p style={{ textAlign: "justify" }}>
                                                    Smart classrooms are equally important in imparting today’s education. KCM Schools believes in providing smart learning platforms to all the students who wish to scale newer heights in today’s era.
                                                </p>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="smart-classrooms" target="_self" className="submenu">
                                                        Smart Classrooms
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="library"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Library
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="computer-lab" target="_self" className="submenu">
                                                        Computer Lab
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="science-lab" className="submenu">
                                                        Science Lab
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="sports" target="_self" className="submenu">
                                                        Sports
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="transport"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Transport
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="skill-lab"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Skill Lab
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="school-clubs"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        School Clubs
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default SmartClassrooms;